import script from "./PlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PlanDetailsPopup.vue?vue&type=style&index=0&id=50b6cb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b6cb2a"]])

export default __exports__